import { useClassroomPolicyStore } from "@/stores/v2/classroomPolicyStore";
import { EditingFocus } from "@/components/FocusLibraryDrawer/FocusPage";
import { ClassRulePrefill } from "@/components/RulesLibraryDrawer/ActiveRules/types";

export function togglePauseForStudentInState(student: string): void {
	const paused: string[] = useClassroomPolicyStore.getState().getPausedStudents();

	if (paused.includes(student)) {
		useClassroomPolicyStore.getState().setPausedStudents(paused.filter((user: string) => user !== student));
	} else {
		useClassroomPolicyStore.getState().setPausedStudents([...paused, student]);
	}
}

/** Builds the Rules Library class-rule prefill for a website or signature a student has open. */
export function buildClassRulePrefill(
	websiteUrl: string | undefined,
	signature: string | undefined,
	studentQoriaId: string | undefined
): ClassRulePrefill {
	const studentIds = studentQoriaId ? [studentQoriaId] : [];

	if (signature) {
		return { target: signature, type: "SIGNATURE", studentIds };
	}

	let target = websiteUrl ?? "";
	try {
		target = new URL(target).hostname || target;
	} catch {
		// Bare domains such as "example.com" are not parseable URLs and are already a usable target.
	}

	return { target, type: "URL", studentIds };
}

export function getFocusedStudentIdsFromAppliedFocuses(appliedFocuses: EditingFocus[]): string[] {
	return appliedFocuses.reduce((acc: string[], focus: EditingFocus) => {
		return [...acc, ...focus.studentIds];
	}, []);
}
